import { ITaskNamespaces, ITaskSnoozeReasons } from 'types/graphqlTypes'

/**
 * value is made up of snoozePeriodValue and snoozePeriodUnit
 * where the unit is ITimeUnitsEnum and value is an integer
 */
export const snoozeUntilOptions = [
  {
    label: '30 mins',
    value: '30 min',
  },
  {
    label: '1 hr',
    value: '1 hour',
  },
  {
    label: '1.5 hrs',
    value: '90 min',
  },
  {
    label: '2 hrs',
    value: '2 hour',
  },
  {
    label: '2.5 hrs',
    value: '180 min',
  },
  {
    label: '1 day',
    value: '1 day',
  },
  {
    label: '2 days',
    value: '2 day',
  },
  {
    label: '3 days',
    value: '3 day',
  },
  {
    label: '4 days',
    value: '4 day',
  },
  {
    label: '5 days',
    value: '5 day',
  },
]

export const schedulingSnoozeReasons = [
  { label: 'Shipper Requested', value: ITaskSnoozeReasons.SHIPPER_REQUESTED },
  { label: 'Receiver Requested', value: ITaskSnoozeReasons.RECEIVER_REQUESTED },
  { label: 'Customer Requested', value: ITaskSnoozeReasons.CUSTOMER_REQUESTED },
  { label: 'Too Early to Schedule', value: ITaskSnoozeReasons.TOO_EARLY_TO_SCHEDULE },
  { label: 'Escalated Internally', value: ITaskSnoozeReasons.ESCALATED_INTERNALLY },
  { label: 'Escalated Externally', value: ITaskSnoozeReasons.ESCALATED_EXTERNALLY },
]

export const trackingSnoozeReasons = [
  { label: 'Arrived Early', value: ITaskSnoozeReasons.ARRIVED_EARLY },
  { label: 'Carrier Not Answering', value: ITaskSnoozeReasons.CARRIER_NOT_ANSWERING },
  { label: 'Drop Trailer', value: ITaskSnoozeReasons.DROP_TRAILER },
  { label: 'Reschedule', value: ITaskSnoozeReasons.RESCHEDULE },
  {
    label: 'Detention Requested at Facility',
    value: ITaskSnoozeReasons.DETENTION_REQUESTED_AT_FACILITY,
  },
  { label: 'Escalated Accessorial', value: ITaskSnoozeReasons.ESCALATED_ACCESSORIAL },
  { label: 'Bounce Requested', value: ITaskSnoozeReasons.BOUNCE_REQUESTED },
  { label: 'Escalated Internally', value: ITaskSnoozeReasons.ESCALATED_INTERNALLY },
  { label: 'Missing Carrier Info', value: ITaskSnoozeReasons.MISSING_CARRIER_INFO },
  { label: 'Driver Lost', value: ITaskSnoozeReasons.DRIVER_LOST },
  { label: 'GPS Integration Pending', value: ITaskSnoozeReasons.GPS_INTEGRATION_PENDING },
  { label: 'Delaying Due to Automation', value: ITaskSnoozeReasons.DELAYING_DUE_TO_AUTOMATION },
]

export const snoozeReasons = {
  [ITaskNamespaces.CE]: trackingSnoozeReasons,
  [ITaskNamespaces.CX]: schedulingSnoozeReasons,
}
